import React from "react";
import { PaginatedAPIActivityType } from "../../../../../../../../libs/Utils/Types/APIManagement";
import { TableColumnsType } from "antd";
import Elipses from "../../../../../../../../global components/Icons/Elipses";
import ReusableTable from "../../../../../../../../global components/Table/Table";
import dayjs from "dayjs";
import s from "./RequestTable.module.scss";
import clsx from "clsx";
import ReusablePopover from "../../../../../../../../global components/Popover/ReuseablePopover";
import ActionPopOverDetails from "../ActionPopOverDetails";
type ColumnType = {
  key: string;
  request: string;
  lastUsed: string; // ISO date string
  keyPreview: string;
  status: string;
};
type PropType = {
  data: PaginatedAPIActivityType["data"];
  loading: boolean;
  mutate: () => void;
};
function RequestTable({ data, loading, mutate }: PropType) {
  const columns: TableColumnsType<ColumnType> = [
    {
      title: "API",
      dataIndex: "keyPreview",
      key: "keyPreview",
      render: (keyPreview: string) => <span>{keyPreview}</span>,
    },
    {
      title: "Last Used",
      dataIndex: "lastUsed",
      key: "lastUsed",
      render: (lastUsed: string) => <span>{lastUsed}</span>,
    },
    {
      title: "Request Volumn (30D)",
      dataIndex: "keyPreview",
      key: "keyPreview",
      render: (keyPreview: string) => <span>{keyPreview}</span>,
    },

    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status: string) => (
        <span
          className={clsx({
            [s.active]: status.toLowerCase().includes("active"),
            [s.inactive]:
              status.toLowerCase().includes("inactive") ||
              status.toLowerCase().includes("disabled"),
            [s.revoked]: status.toLowerCase().includes("revoked"),
          })}
        >
          {status}
        </span>
      ),
    },
    {
      title: "Actions",
      dataIndex: "actions",
      key: "actions",
      render: (
        actions: string,
        record: { key: string; keyPreview: string }
      ) => (
        <ReusablePopover
          content={
            <ActionPopOverDetails
              id={record.key}
              previewAPI={record.keyPreview}
              mutate={mutate}
            />
          }
        >
          <Elipses width={24} height={24} />
        </ReusablePopover>
      ),
    },
  ];
  const dataSource: ColumnType[] = data.map((item) => ({
    key: item.id,
    request: item.name,

    keyPreview: item.keyPrefix,
    status: item.status,
    lastUsed: item.lastUsed
      ? dayjs.utc(item.lastUsed).local().format("YYYY-MM-DD hh:mm:ss")
      : "Not yet used",
  }));
  return (
    <ReusableTable
      columns={columns}
      dataSource={dataSource}
      loading={loading}
    />
  );
}

export default RequestTable;
